/* eslint-disable react/prop-types */
import { Cancel } from "@mui/icons-material";
import ArticleIcon from "@mui/icons-material/Article";
import BusinessIcon from "@mui/icons-material/Business";
import CloseIcon from "@mui/icons-material/Close";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  Tab,
  Tabs,
  Link,
  Typography,
  useMediaQuery,
} from "@mui/material";
import theme from "assets/theme";
import CustomTabPanel from "components/CustomPanel/customPanel";
import { useEffect, useMemo, useState } from "react";
import { JsonTool } from "utils/jsonTools";
import {
  checkGroupUser,
  ID_GROUP_CHUTHE,
  ID_GROUP_CAPTINH,
  ID_GROUP_HOIDONG,
  ID_GROUP_NUMBER_ONE,
  ID_GROUP_NUMBER_SEVEN,
  ID_GROUP_PHUONGXA,
  PaperComponent,
  API_URL_DOWNLOAD,
  checkUrlTep,
} from "../../utils/constants";
import useAuth from "hooks/useAuth";
import AssignmentIcon from "@mui/icons-material/Assignment";
import { DownloadIcon } from "@primer/octicons-react";

const DetailDangKySanPham = ({
  data,
  open,
  onClose,
  fieldInfor,
  fieldContent,
}) => {
  // state lỗi giá trị từ form
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  const { user } = useAuth();

  //kiểm tra đang đăng nhập với nhóm hội đồng = 6
  const isHoiDong = useMemo(() => {
    return checkGroupUser(user, ID_GROUP_HOIDONG);
  }, [user]);
  //Kiểm tra nhóm người dùng là 5
  const isGroupNumberFive = useMemo(() => {
    return checkGroupUser(user, ID_GROUP_CHUTHE);
  }, [user]);
  //Kiểm tra nhóm người dùng là 1
  const isGroupNumberOne = useMemo(() => {
    return checkGroupUser(user, ID_GROUP_NUMBER_ONE);
  }, [user]);
  //Kiểm tra nhóm người dùng là 7
  const isGroupNumberSeven = useMemo(() => {
    return checkGroupUser(user, ID_GROUP_NUMBER_SEVEN);
  }, [user]);
  //kiểm tra nhóm người dùng là 8 - phường/xã
  const isGroupNumberEight = useMemo(() => {
    return checkGroupUser(user, ID_GROUP_PHUONGXA);
  }, [user]);
  //kiểm tra nhóm người dùng là 9 - cấp tỉnh
  const isGroupNumberNine = useMemo(() => {
    return checkGroupUser(user, ID_GROUP_CAPTINH);
  }, [user]);

  const [value, setValue] = useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handelClear = () => {
    onClose();
  };
  useEffect(() => {
    if (open) {
      setValue(0);
    }
  }, [open]);

  return (
    <Dialog
      fullScreen={fullScreen}
      open={open}
      PaperComponent={PaperComponent}
      onClose={handelClear}
      scroll="paper"
      PaperProps={{
        sx: {
          "@media (min-width: 768px)": {
            minWidth: "40rem",
          },
          height: "100%",
        },
      }}
    >
      {/* Form*/}
      <Box
        style={{
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
          height: "100%",
        }}
      >
        {/* Tiêu đề modal - tham số title */}
        <DialogTitle sx={{ m: 0, p: 2, backgroundColor: "#ffffff" }}>
          Chi tiết đăng ký sản phẩm OCOP
          <IconButton
            aria-label="close"
            onClick={handelClear}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <Box
          sx={{
            width: "100%",
            bgcolor: "background.paper",
            borderColor: "divider",
            padding: "1rem 1rem 0 1rem",
          }}
        >
          <Tabs
            value={value}
            onChange={handleChange}
            indicatorColor="secondary"
            textColor="primary"
            variant="fullWidth"
          >
            <Tab
              icon={<BusinessIcon />}
              label="Thông tin"
              {...JsonTool.a11yProps(0)}
            />
            <Tab
              icon={<ArticleIcon />}
              label="Tệp đính kèm"
              {...JsonTool.a11yProps(1)}
            />
            {(isHoiDong ||
              isGroupNumberNine ||
              isGroupNumberOne ||
              isGroupNumberSeven ||
              isGroupNumberEight ||
              isGroupNumberFive) && (
              <Tab
                icon={<AssignmentIcon />}
                label="Nội dung báo cáo cấp xã"
                {...JsonTool.a11yProps(2)}
              />
            )}
          </Tabs>
        </Box>
        <DialogContent dividers sx={{ overflow: "auto", paddingTop: "0" }}>
          <CustomTabPanel value={value} index={0}>
            <Grid
              container
              spacing={1}
              border={"2px solid #d6d6d6"}
              sx={{ borderRadius: "0.5rem" }}
            >
              {fieldInfor &&
                fieldInfor.length > 0 &&
                fieldInfor.map((item) => (
                  <Grid
                    item
                    xs={item?.xs}
                    md={item?.md}
                    lg={item?.lg}
                    key={item?.key + "inforField"}
                    sx={{
                      borderBottom: "1px solid #d6d6d6",
                      borderRight: "1px solid #d6d6d6",
                    }}
                  >
                    <Typography fontSize={"0.75rem"} fontWeight={"500"}>
                      {item?.name}:
                    </Typography>
                    <Typography fontSize={"1rem"}>
                      {data?.[item?.key]
                        ? data?.[item?.key]
                        : "Đang cập nhập ..."}
                    </Typography>
                  </Grid>
                ))}
            </Grid>
          </CustomTabPanel>
          <CustomTabPanel value={value} index={1}>
            {data &&
              data.id &&
              (data.tepdinhkem_phieudangky &&
              data.tepdinhkem_phieudangky.length > 0 ? (
                <Grid container p="0 1rem 1rem 1rem">
                  <Grid
                    container
                    style={{
                      color: "#000000",
                      backgroundColor: "rgb(142 199 243)",
                    }}
                    fontSize={"1rem"}
                    fontWeight={600}
                    pb={"0.5rem"}
                    m={"0.5rem 0"}
                    spacing={1}
                    borderBottom={"2px solid #3F51B5"}
                  >
                    <Grid item xs={2}>
                      STT
                    </Grid>
                    <Grid item xs={8}>
                      Tên tệp đính kèm
                    </Grid>
                    <Grid item xs={2}>
                      Tải về
                    </Grid>
                  </Grid>
                  {data.tepdinhkem_phieudangky?.map((tep, index) => (
                    <Grid
                      container
                      key={tep?.id + index}
                      style={{ color: "#000000" }}
                      fontSize={"1rem"}
                      borderBottom={"1px solid #d6d6d6"}
                      pb={"0.5rem"}
                      mb={"0.5rem"}
                      ml={0}
                      spacing={1}
                    >
                      <Grid item xs={2}>
                        {index + 1}
                      </Grid>
                      <Grid item xs={8}>
                        {tep?.tentepdinhkem}
                      </Grid>
                      <Grid
                        item
                        xs={2}
                        display={"flex"}
                        alignItems={"center"}
                        justifyContent={"center"}
                        style={{ paddingTop: "0px" }}
                      >
                        <Typography variant="h5" color="info">
                          <Link
                            target="_blank"
                            href={
                              API_URL_DOWNLOAD + checkUrlTep(tep?.tepdinhkem)
                            }
                          >
                            <DownloadIcon />
                          </Link>
                        </Typography>
                      </Grid>
                    </Grid>
                  ))}
                </Grid>
              ) : (
                <Grid
                  container
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                  p="1rem"
                  height="100%"
                >
                  <Typography
                    style={{
                      fontSize: "1.25rem",
                      fontWeight: "500",
                      lineHeight: "1.5rem",
                      color: "black",
                    }}
                  >
                    Không có thông tin Tệp đính kèm
                  </Typography>
                </Grid>
              ))}
          </CustomTabPanel>
          <CustomTabPanel value={value} index={2}>
            {/* <Box height={"100%"}>
              <ContentReportSubDistrict data={data} height={"410px"} />
            </Box> */}
            <Grid
              container
              spacing={1}
              border={"2px solid #d6d6d6"}
              sx={{ borderRadius: "0.5rem" }}
            >
              {fieldContent &&
                fieldContent.length > 0 &&
                fieldContent.map((item) => (
                  <Grid
                    item
                    xs={item?.xs}
                    md={item?.md}
                    lg={item?.lg}
                    key={item?.key + "contentField"}
                    sx={{
                      borderBottom: "1px solid #d6d6d6",
                      borderRight: "1px solid #d6d6d6",
                    }}
                  >
                    <Typography fontSize={"0.75rem"} fontWeight={"500"}>
                      {item?.name}:
                    </Typography>
                    <Typography fontSize={"1rem"}>
                      {data?.[item?.key]
                        ? data?.[item?.key]
                        : "Đang cập nhập ..."}
                    </Typography>
                  </Grid>
                ))}
            </Grid>
          </CustomTabPanel>
        </DialogContent>
        <DialogActions>
          <Button
            type="submit"
            variant="contained"
            startIcon={<Cancel />}
            size="small"
            onClick={handelClear}
            sx={{ color: "#ffffff", float: "right", mr: 1 }}
          >
            Đóng
          </Button>
        </DialogActions>
      </Box>
    </Dialog>
  );
};

export default DetailDangKySanPham;
